var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("application-automation-settings-loader")
    : _c("div", { staticClass: "application-automation-settings-container" }, [
        !_vm.defaultListId
          ? _c("div", { staticClass: "card p-3" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h3", { staticClass: "bold text-grey mb-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("automations.applicationLevelSettings.title")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "text-light-gray mb-2 mb-lg-0" }, [
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "automations.applicationLevelSettings.subtitle"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "automations.applicationLevelSettings.description"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "d-flex justify-content-center",
            attrs: { id: "application-automation-settings-form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card p-4" },
              [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "automations.applicationLevelSettings.campaignsDetails"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("campaign-from-section", {
                  attrs: {
                    label: false,
                    "from-data": _vm.fromData,
                    emails: _vm.GET_MARKETING_EMAILS,
                  },
                  on: { change: _vm.handleChangeFromData },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "automations.applicationLevelSettings.listDetails"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("list-details", {
                      attrs: {
                        "import-contacts": false,
                        list: _vm.localDefaultList,
                        visibility: _vm.listVisibility,
                      },
                      on: { change: _vm.handleChangeList },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row align-items-center my-3 my-xl-0" },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "h6",
                        {
                          staticClass:
                            "bold text-light-gray font-sm mb-2 mb-lg-0",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.words.time")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row my-0 align-items-center moregage-form" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xl-11 col-sm-11 col-12 order-lg-1 order-2 d-flex flex-column",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row mb-2 align-items-center" },
                          [
                            _c("div", { staticClass: "col-12 col-lg-4" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "bold text-light-gray font-sm mb-2 mb-lg-0",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "automations.applicationLevelSettings.defaultAutomationTime"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-8" },
                              [
                                _c(
                                  "material-input",
                                  {
                                    staticClass: "position-relative",
                                    attrs: {
                                      value: _vm.localApplicationAutomationTime,
                                    },
                                  },
                                  [
                                    _c("time-input", {
                                      attrs: {
                                        label: _vm.$t("global.words.time"),
                                        "hidden-label": "",
                                        value:
                                          _vm.localApplicationAutomationTime,
                                        "default-value":
                                          _vm.localApplicationAutomationTime,
                                      },
                                      on: {
                                        input: _vm.handleChangeAutomationTime,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row no-gutters justify-content-end mt-3" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-auto mr-2" },
                      [
                        _vm.defaultListId
                          ? _c("router-link", {
                              key: "cancel-settings",
                              attrs: {
                                id: "cancel-settings",
                                to: _vm.applicationAutomationRootRoute,
                                custom: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var navigate = ref.navigate
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-sm btn-white",
                                            attrs: { role: "link" },
                                            on: {
                                              click: navigate,
                                              keypress: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return navigate.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t("global.words.cancel")
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2853888745
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _c(
                          "simple-button",
                          {
                            ref: "submitButton",
                            attrs: {
                              "class-name": "btn-sm",
                              type: "primary",
                              loading: _vm.submitting.loading,
                              "loading-succeeded": _vm.submitting.status,
                              disabled: !_vm.isValid,
                            },
                            on: { click: _vm.handleSubmit },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.actions.saveChanges")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }